import React, { Component } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import MenuItem from "@material-ui/core/MenuItem"
// import "react-select/dist/react-select.css"
import Input from "@material-ui/core/Input"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import LinearProgress from "@material-ui/core/LinearProgress"
import PlacesAutocomplete, {
  geocodeByPlaceId,
  getLatLng,
} from "react-places-autocomplete"
import classNames from "classnames"
class Option extends React.Component {
  handleClick = event => {
    this.props.onSelect(this.props.option, event)
  }

  render() {
    const { children, isFocused, isSelected, onFocus } = this.props
    return (
      <MenuItem
        onFocus={onFocus}
        selected={isFocused}
        disabled={isSelected}
        // onClick={this.handleClick}
        component="div"
        className={this.props.className}
        style={{
          fontWeight: isSelected ? 500 : 400,
          ...this.props.style,
        }}
        onClick={this.props.onClick}
      >
        {children}
        {children === "LOADING..." && (
          <LinearProgress
            style={{
              position: "absolute",
              width: "100%",
              bottom: "0",
              left: "0",
              height: "2px",
            }}
          />
        )}
      </MenuItem>
    )
  }
}

const googleComponents = [
  { googleComponent: `sublocality_level_1`, key: `city` },
  { googleComponent: `locality`, key: `city` },
  { googleComponent: `administrative_area_level_1`, key: `state` },
  { googleComponent: `postal_code`, key: `zip` },
  { googleComponent: `street_number`, key: `street_number` },
  { googleComponent: `route`, key: `route` },
  { googleComponent: `country`, key: `country` },
]

let addressComponents = {}

const populateObject = (addressComponent, formMap) => {
  const addressType = addressComponent.types[0]
  if (formMap.googleComponent === addressType) {
    const formValue = addressComponent.long_name
    addressComponents[formMap.key] = formValue
  }
}

class AddressAutoCompleteComponent extends Component {
  state = {
    value: "",
  }
  componentDidMount() {
    if (this.props.value) {
      this.handlePlacesChange(this.props.value)
    }
  }
  handlePlacesChange = value => {
    this.setState({ value })
  }
  handlePlacesSelect = (address, placeId) => {
    this.setState({ value: address })
    geocodeByPlaceId(placeId).then(res => {
      for (const component in googleComponents) {
        const addressComponents = res[0].address_components
        addressComponents.forEach(addressComponent =>
          populateObject(addressComponent, googleComponents[component])
        )
      }
      getLatLng(res[0]).then(({ lat, lng: lon }) => {
        const selectedPlace = {
          ...addressComponents,
          lat,
          lon,
        }
        this.props.onChange(selectedPlace)
      })
    })
  }
  render() {
    const { classes, className, InputClasses, InputProps } = this.props
    const { label, ...restInputProps } = InputProps
    const searchOptions = {
      types: [],
    }
    return (
      <PlacesAutocomplete
        value={this.state.value}
        onChange={this.handlePlacesChange}
        onSelect={this.handlePlacesSelect}
        searchOptions={searchOptions}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
          return (
            <div className={classNames(classes.wrapper, className)}>
              <FormControl fullWidth>
                <InputLabel htmlFor="description">{label}</InputLabel>
                <Input
                  fullWidth
                  classes={{
                    input: classes.input,
                    ...InputClasses,
                  }}
                  {...getInputProps({
                    className: "location-search-input",
                    autoComplete: "nope",
                    ...restInputProps,
                  })}
                />
              </FormControl>
              <div
                className={classNames("autocomplete-dropdown-container", {
                  "Select-menu-outer": suggestions.length > 0 || loading,
                })}
              >
                {loading && <Option>LOADING...</Option>}
                {suggestions
                  .filter(s => s.types.indexOf("country") === -1)
                  .map(suggestion => {
                    const className = suggestion.active
                      ? "suggestion-item--active"
                      : "suggestion-item"
                    // inline style for demonstration purpose
                    const style = suggestion.active
                      ? {
                          backgroundColor: "rgba(0, 0, 0, 0.08)",
                          cursor: "pointer",
                        }
                      : { backgroundColor: "#ffffff", cursor: "pointer" }
                    return (
                      <MenuItem
                        {...getSuggestionItemProps(suggestion, {
                          className,
                          style,
                        })}
                      >
                        <span>
                          {suggestion.terms[0]
                            ? suggestion.terms[0].value + " "
                            : ""}
                          {suggestion.terms[1]
                            ? suggestion.terms[1].value + ", "
                            : ""}
                          {suggestion.terms[2] ? suggestion.terms[2].value : ""}
                        </span>
                      </MenuItem>
                    )
                  })}
              </div>
            </div>
          )
        }}
      </PlacesAutocomplete>
    )
  }
}

export default withStyles(styles, { withTheme: true })(
  AddressAutoCompleteComponent
)
